import "./BtnGoBack.css";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PropTypes from "prop-types";
/**
 * Ofrece navegación hacia atrás. Renderiza
 * un ícono de flecha hacia la izquierda y una leyenda (opcional). Al hacer clic,
 * navega un paso hacia atrás en el historial del navegador.
 * @component
 * @param {string} [props.caption] - Texto a mostrar junto al ícono de retroceso.
 * Si se omite, solo se muestra el ícono.
 * @returns {JSX.Element} Un elemento button que navega hacia atrás al hacer clic.
 *
 * @example
 * <BtnGoBack caption="Volver" />
 */
export const BtnGoBack = ({ caption, size = "small", border = true, className = "" }) => {
  const navigate = useNavigate();

  const variants = () => {
    if (size === "default") {
      return "default";
    }

    if (size === "small") {
      return "small";
    }

    if (size === "large") {
      return "large";
    }
  };

  return (
    <div className="btn-goback-container">
      <button className={`btn-goback-style ${className}`} onClick={() => navigate(-1)}>
        <ArrowBackIosIcon className="btn-goback-icon" />
        <span className={`btn-goback-caption ${variants()}`}>{caption}</span>
      </button>

      {border && <div className="btn-goback-border" />}
    </div>
  );
};

BtnGoBack.propTypes = {
  caption: PropTypes.string,
  size: PropTypes.string,
  border: PropTypes.bool,
  className: PropTypes.string,
};
